import React from "react";
import { Row, Col } from "reactstrap";
import AmazonProductListingEditableField from "./AmazonProductListingEditableField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import EditIcon from '../../../../../designUtils/OpsDashboard/AccountDetails/EditIcon.svg'

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function normalizeImages(val) {
  if (!val) return [];

  if (Array.isArray(val)) {
    return val
      .map((item) => {
        if (typeof item === "string") return item;

        if (typeof item === "object") {
          return (
            item.media_location ||
            item.link ||
            item.url ||
            null
          );
        }

        return null;
      })
      .filter(Boolean);
  }

  return [];
}

function AmazonProductListingFieldRow(props) {
  const catalogVal = get(props.field, "catalog.value", null);
  const listingVal = get(props.field, "listing.value", null);

  if (!props.field) return null;

  var isMandatory = get(props.field, "schema.is_mandatory", false);
  var status = get(props.field, "validation.status", "VALID");
  var label = props.field.label || props.field.field || "";
  var description = get(props.field, "schema.description", "");

  var statusClass = status ? status.toLowerCase() : "valid";
  
  const isImageField =
    props.field.field === "images" ||
    (props.field.field && props.field.field.includes("image_locator")) ||
    (props.field.ui && props.field.ui.input_type === "image");

  const isBulletField = 
    (props.field.field && props.field.field.toLowerCase().includes('bullet')) ||
    (label.toLowerCase().includes('bullet'));

  const isUpdated = props.changedFields && props.changedFields.hasOwnProperty(props.field.field);
  const updatedValue = isUpdated ? props.changedFields[props.field.field].value : undefined;

  function renderValue(val, isBullet = false) {
    if (val === null || val === undefined) return "—";
  
    if (typeof val === "string") {
      return val.replace(/<\/?p>/gi, " ").trim();
    }

    if (Array.isArray(val)) {
      if (val.length === 0) return "—";
      
      if (isBullet) {
        return (
          <ul style={{ paddingLeft: '20px', margin: 0 }}>
            {val.map((item, i) => (
              <li key={i} className="field-value-object-group" style={{ marginBottom: '6px' }}>
                {renderValue(item, isBullet)}
              </li>
            ))}
          </ul>
        );
      } else {
        return val.map((item, i) => (
          <div key={i} className="field-value-object-group" style={{ marginBottom: '8px' }}>
            {renderValue(item, isBullet)}
          </div>
        ));
      }
    }
  
    if (typeof val === "object") {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginLeft: '4px' }}>
          {Object.entries(val).map(([k, v]) => (
            <div key={k} className="field-value-object" style={{ fontSize: '11px' }}>
              <b style={{ color: '#555', marginRight: '4px' }}>{k}:</b> 
              {typeof v === 'object' && v !== null ? (
                <div style={{ paddingLeft: '8px', borderLeft: '1px solid #ccc', margin: '2px 0' }}>
                  {renderValue(v, isBullet)}
                </div>
              ) : (
                <span>{typeof v === "string" ? v.replace(/<\/?p>/gi, " ").trim() : String(v)}</span>
              )}
            </div>
          ))}
        </div>
      );
    }
  
    return String(val);
  }

  return (
    <Row className="g-2 px-3 py-2 border-bottom align-items-center m-0 field-row-container">
      <Col md={2} className="field-row-label" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
      <p className='mb-0'>
          {label} 
          {isMandatory && <span className="field-row-mandatory text-danger ms-1"  style={{ fontSize: "17px", fontWeight: "bold" }}>*</span>}
          
          {description && (
            <span title={description} style={{ cursor: "pointer", marginLeft: "8px", color: "#6c757d" }}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </span>
          )}
        </p>
      </Col>
      
      <Col md={3}>
        {isImageField ? (
          <div className="field-image-container">
            {normalizeImages(catalogVal).map((img, i) => (
              <img key={i} src={img} alt="img" className="field-image-item" />
            ))}
          </div>
        ) : (
          <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
            {renderValue(catalogVal, isBulletField)}
          </div>
        )}
      </Col>

      <Col md={3}>
        {isImageField ? (
          <div className="field-image-container">
            {normalizeImages(listingVal).map((img, i) => (
              <img key={i} src={img} alt="img" className="field-image-item" />
            ))}
          </div>
        ) : (
          <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
            {renderValue(listingVal, isBulletField)}
          </div>
        )}
      </Col>
      
      <Col md={3}>

{isImageField ? (

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap"
    }}
  >

<div className="field-image-container">
  {normalizeImages(
  isUpdated
    ? [updatedValue]
    : listingVal
).map((img, i) => (
    <img
      key={i}
      src={img}
      alt="img"
      className="field-image-item"
    />
  ))}
</div>
<img
  src={EditIcon}
  alt="Edit"
  style={{
    width: "16px",
    height: "16px",
    cursor: "pointer"
  }}
  onClick={() => props.action(props.field)}
/>

  </div>

) : (

  <AmazonProductListingEditableField 
    field={props.field} 
    onFieldChange={props.onFieldChange}  
    changedValue={updatedValue}
    isUpdated={isUpdated}
  />

)}

</Col>
      
      <Col md={1}>
        <span className={`status-badge status-badge-${statusClass}`}>
          {status}
        </span>
      </Col>
    </Row>
  );
}

export default AmazonProductListingFieldRow;